var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "header flex_box" },
    [
      _c(
        "div",
        {
          staticClass: "left",
          staticStyle: { display: "flex", "align-items": "center" },
        },
        [
          _c(
            "a",
            { attrs: { href: "../" } },
            [
              _c("svg-icon", {
                staticStyle: { "margin-right": "7px" },
                attrs: {
                  "icon-class": "icon",
                  "class-name": "icon-icon",
                  alt: "Icon",
                },
              }),
              _c("span", [_vm._v(_vm._s(_vm.$t("header.title")))]),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "right" }, [
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showUpgradeBtn,
                expression: "showUpgradeBtn",
              },
            ],
            staticClass: "upgrde",
            on: { click: _vm.showPricingPop },
          },
          [
            _c("svg-icon", {
              attrs: { "icon-class": "upgrade", "class-name": "upgrade" },
            }),
            _c("span", [_vm._v(_vm._s(_vm.$t("btn.tips_upgrade")))]),
          ],
          1
        ),
        _c(
          "span",
          { staticClass: "history" },
          [
            _c("svg-icon", {
              attrs: { "icon-class": "history", "class-name": "history-svg" },
            }),
            _c("span", [_vm._v(_vm._s(_vm.$t("btn.history")))]),
          ],
          1
        ),
        _c(
          "span",
          { staticClass: "login", on: { click: _vm.loginFn } },
          [
            _c("svg-icon", {
              attrs: { "icon-class": "login", "class-name": "login-svg" },
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.islog,
                    expression: "!islog",
                  },
                ],
              },
              [_vm._v(_vm._s(_vm.$t("btn.login")))]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "photo_rights" }, [
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowCredits,
                  expression: "isShowCredits",
                },
              ],
              staticClass: "creditsContent",
            },
            [
              _vm._v(_vm._s(_vm.$t("header.available_credits")) + ": "),
              _c("span", [_vm._v(_vm._s(_vm.creditsNum))]),
              _vm._v(" " + _vm._s(_vm.$t("header.credits"))),
            ]
          ),
          _c("p", { staticClass: "info" }, [
            _c("span", [
              _c("i", { staticClass: "num" }, [_vm._v(_vm._s(_vm.num))]),
              _vm._v(" " + _vm._s(_vm.$t("header.hd"))),
            ]),
            _vm._v(" " + _vm._s(_vm.$t("header.watermarks")) + " "),
            _c("a", { attrs: { href: _vm.url, target: "_blank" } }, [
              _vm._v(_vm._s(_vm.$t("header.view_details")) + ">>"),
            ]),
          ]),
          _c(
            "a",
            {
              staticClass: "btn upgrade_btn",
              attrs: { href: "javascript:void(0);" },
              on: { click: _vm.showPricingPop },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.isvip
                    ? _vm.$t("header.buy_more")
                    : _vm.$t("btn.tips_upgrade")
                )
              ),
            ]
          ),
        ]),
        _c(
          "div",
          { staticClass: "photo_rights_load" },
          [
            _c("svg-icon", {
              attrs: {
                "icon-class": "load",
                "class-name": "load",
                alt: "Load",
              },
            }),
            _c("p", [_vm._v(_vm._s(_vm.$t("header.loading")))]),
          ],
          1
        ),
      ]),
      _c("History", { on: { showPricingPop: _vm.showPricingPop } }),
      _c("Pricing", {
        attrs: { showmodule: _vm.showmodule },
        on: { closePricingPop: _vm.closePricingPop },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }